import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { IncomingCallCard } from "./IncomingCallCard";

interface IncomingCallDialogProps {
  isOpen: boolean;
  onAccept: () => void;
  onReject: () => void;
  callerInfo: {
    number: string;
    name?: string;
    location?: string;
    source?: string;
    company?: string;
    callSid: string;
    calledNumber?: string;
  };
  callerInsights?: any;
}

/** Dashboard incoming call: the light IncomingCallCard in a modal. */
const IncomingCallDialog: React.FC<IncomingCallDialogProps> = ({
  isOpen,
  onAccept,
  onReject,
  callerInfo,
  callerInsights
}) => (
  <Dialog open={isOpen} onOpenChange={() => {}}>
    <DialogContent className="sm:max-w-md p-0 border-0 bg-transparent shadow-none [&>button]:hidden">
      <DialogTitle className="sr-only">Incoming call from {callerInfo.name || callerInfo.number}</DialogTitle>
      <DialogDescription className="sr-only">Accept or decline the call.</DialogDescription>
      <IncomingCallCard
        number={callerInfo.number}
        calledNumber={callerInfo.calledNumber}
        insights={callerInsights}
        fallbackName={callerInfo.name}
        fallbackCompany={callerInfo.company}
        onAccept={onAccept}
        onDecline={onReject}
      />
    </DialogContent>
  </Dialog>
);

export default IncomingCallDialog;
